import config from '../config/report-day.json' with { type: 'json' }

export const DAY_HOUR = config.hour
const pad = n => String(n).padStart(2, '0')
export function businessDate(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: config.timezone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(now)
  const p = Object.fromEntries(parts.map(part => [part.type, part.value]))
  return addDays(`${p.year}-${p.month}-${p.day}`, Number(p.hour) < DAY_HOUR ? -1 : 0)
}
export function addDays(date, days) {
  const d = new Date(`${date}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}
export function dayStart(date = businessDate()) { return `${date}T${pad(DAY_HOUR)}:00:00` }
export function dayEnd(date = businessDate()) { return `${addDays(date, 1)}T${pad(DAY_HOUR - 1)}:59:59` }
export function dayRange() { return { start: dayStart(), end: dayEnd() } }
export function reportBoundary(value, end = false) {
  if (!value) return ''
  const text = String(value).replace(' ', 'T')
  return /^\d{4}-\d{2}-\d{2}$/.test(text) ? (end ? dayEnd(text) : dayStart(text)) : text
}
export function businessCalendarDate() { return new Date(`${businessDate()}T12:00:00`) }
